import { render, staticRenderFns } from "./QunfengBanner.vue?vue&type=template&id=73a4b379&scoped=true"
import script from "./QunfengBanner.vue?vue&type=script&lang=js"
export * from "./QunfengBanner.vue?vue&type=script&lang=js"
import style0 from "./QunfengBanner.vue?vue&type=style&index=0&id=73a4b379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4b379",
  null
  
)

export default component.exports